import React from 'react';
import "./footer.css"


const Footer = () => {
  return (
    <div className='fixed-footer'>
        <footer className='footer'>
            <div className='content'><span> © by_third_eye</span></div>
        </footer>
    </div>
  )
}

export default Footer